export default __webpack_public_path__ + "static/media/a011-startup-2.d440ffbb.svg";